export const selectPathname = () => window.location.pathname;
